<template>
	<div class="card">

		<div class="float-right" style="font-size:12px;width:60%">
			Email automation considers properties with BWOFs overdue or due within 6 weeks.
			'Initial' email is for first notification with BWOF due within 6 weeks (as long as more than 7 days away).
			'Follow Up' is for BWOF due within 14 days, and already sent email at least 14 days ago.
			'Urgent' is for BWOF due within 7 days and haven't already emailed supplier within last 7 days. Cc Customer contacts with automation enabled.
			'Overdue' is repeated when BWOF date has passed, and haven't emailed supplier in 7 days.
		</div>

		<h2 class="pull-left">Outbound BWOF Emails</h2>

		<OutboundEmailList emailModuleType="bwof" dueDateColumnHeader="BWOF Due" />

	</div>
</template>

<script lang="ts">

</script>